import { Injectable } from '@angular/core';
import { ConfigService } from '@app/app-config.service';

export enum LogLevel {
  General = 0,
  Debug = 1,
  Info = 2,
  Warn = 3,
  Error = 4,
  Fatal = 5,
  Off = 6
}
@Injectable()
export class LogService {

  constructor(private configService: ConfigService) { }
  logger_config = this.configService.get('logger');
  logWithDate: boolean = this.logger_config.logWithDate;


  debug(msg: string, ...optionalParams: any[]) {
    this.writeToLog(msg, LogLevel.Debug, optionalParams);
  }

  info(msg: string, ...optionalParams: any[]) {
    this.writeToLog(msg, LogLevel.Info, optionalParams);
  }

  warn(msg: string, ...optionalParams: any[]) {
    this.writeToLog(msg, LogLevel.Warn, optionalParams);
  }

  error(msg: string, ...optionalParams: any[]) {
    this.writeToLog(msg, LogLevel.Error, optionalParams);
  }

  fatal(msg: string, ...optionalParams: any[]) {
    this.writeToLog(msg, LogLevel.Fatal, optionalParams);
  }

  log(msg: string, ...optionalParams: any[]) {
    this.writeToLog(msg, LogLevel.General, optionalParams);
  }

  apiSuccess(resTime: number, msg: any, url: string) {
    this.writeToLog(msg, LogLevel.General, [url, resTime + 's']);
  }

  apiError(resTime: number, msg: any, url: string) {
    this.writeToLog(msg, LogLevel.Error, [url, resTime + 's']);
  }

  private writeToLog(msg: string, level: LogLevel, params: any[]) {
    if (this.shouldLog(level)) {
      let value: string = "";

      // Build log string
      if (this.logWithDate) {
        value = new Date() + " - ";
      }

      value += "Type: " + LogLevel[level];
      value += " - Message: " + msg;
      if (params.length) {
        value += " - Extra Info: " + this.formatParams(params);
      }

      console.log("Error log===>", value);
      // Log the value
    }
  }

  private shouldLog(level: LogLevel): boolean {
    let ret: boolean = false;
    // Check from configuration
    if (this.logger_config.logEnable && this.logger_config.isEnabled[LogLevel[level]]) {
      ret = true;
    }
    return ret;
  }

  private formatParams(params: any[]): string {
    let ret: string = params.join(", ");

    // Is there at least one object in the array?
    if (params.some(p => typeof p == "object")) {
      ret = "";

      // Build comma-delimited string
      for (let item of params) {
        ret += JSON.stringify(item) + ",";
      }
    }
    return ret;
  }
}